import { Outlet } from "react-router-dom";
import ContentWrapper from "./ContentWrapper";
import { Box } from "@mui/material";

export default function PublicDocumentLayout() {
  return (
    <>
        <ContentWrapper>
          <Box sx={{m:4}}>
          <Outlet /> {/* renders child routes */}
          </Box>
        </ContentWrapper>
    </>
  );
}
